export default "assets/wechat-f86d2dd5.svg";